import { render } from "./IconSubMenu.vue?vue&type=template&id=2d14a6d9"
import script from "./IconSubMenu.vue?vue&type=script&lang=js"
export * from "./IconSubMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/WIMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__